export default "__VITE_ASSET__ynJhkVN9__"